import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./SaleConsumptionSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import Axios from "axios";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const keyTotalUnit = "TOTAL_UNIT";
const keyTotalDisplay = "TOTAL_DISPLAY_VALUE";

const title = {};

class InventoryImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    noFile: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          noFile: false,
        });
      })
      .catch((res) => {
        this.setState({
          loading: false,
          noFile: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="https://aboss.foodzaps.com/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  calculateRoundValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return partOne;
  };

  calculateRoundNumberValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return Filter.displayNumber(partOne);
  };

  setInOutItems = (
    results,
    items,
    tableTitle,
    period,
    displayType,
    itemsName
  ) => {
    let values = [];

    items.sort((a, b) =>
      itemsName[a].name.toLowerCase() > itemsName[b].name.toLowerCase() ? 1 : -1
    );
    const itemsLength = items.length;
    for (var m = 0; m < itemsLength; m++) {
      const item = items[m];
      if (item === undefined) {
        continue;
      }
      const type = displayType == 1 ? keyTotalDisplay : keyTotalUnit;
      const unitName =
        itemsName[item].unit !== undefined && itemsName[item].unit
          ? itemsName[item].unit
          : "--";
      const displayName =
        itemsName[item].display !== undefined && itemsName[item].display
          ? itemsName[item].display
          : "--";

      const name =
        itemsName[item].name !== undefined ? itemsName[item].name : "--";
      const openBalance =
        results[type + "_" + item + "_OPEN_BALANCE_" + period] !== undefined
          ? results[type + "_" + item + "_OPEN_BALANCE_" + period]
          : "--";
      const totalIn =
        results[type + "_" + item + "_IN_" + period] !== undefined
          ? results[type + "_" + item + "_IN_" + period]
          : 0;
      const totalOut =
        results[type + "_" + item + "_OUT_" + period] !== undefined
          ? results[type + "_" + item + "_OUT_" + period]
          : 0;
      const stockDiscrepancy =
        results[type + "_" + item + "_DISCREPANCY_" + period] !== undefined
          ? results[type + "_" + item + "_DISCREPANCY_" + period]
          : "--";
      const balance =
        results[type + "_" + item + "_CLOSE_BALANCE_" + period] !== undefined
          ? results[type + "_" + item + "_CLOSE_BALANCE_" + period]
          : "--";

      if (displayType === 1) {
        values.push({
          name: name + " (" + displayName + ")",
          val: [
            openBalance !== "--" ? Filter.displayCurrency(openBalance) : "--",
            Filter.displayCurrency(totalIn),
            Filter.displayCurrency(totalOut),
            Filter.displayCurrency(stockDiscrepancy),
            balance !== "--" ? Filter.displayCurrency(balance) : "--",
          ],
        });
      } else {
        values.push({
          name: name + " (" + unitName + ")",
          val: [
            openBalance !== "--" ? Filter.numberFormat(openBalance) : "--",
            Filter.numberFormat(totalIn),
            Filter.numberFormat(totalOut),
            Filter.numberFormat(stockDiscrepancy),
            balance !== "--" ? Filter.numberFormat(balance) : "--",
          ],
        });
      }
    }

    if (values.length <= 0) {
      return (
        <Table2 title={tableTitle}>
          <tr>
            <td colSpan="4">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    return (
      <Table2 title={tableTitle} col={4}>
        <Row
          styleRow={styleRowTotal}
          name={"Stock Name"}
          values={[
            "Open Balance",
            "Total In",
            "Total Out",
            "Discrepancy",
            "Balance",
          ]}
        ></Row>
        {values.map((value, key) => {
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.noFile) {
      return <NoData></NoData>;
    }

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis };

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames };
      const controllers = [...analysis.controllerIds];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }

      const items = [...analysis.items] || [];
      const summaries = { ...analysis.summaries } || {};
      const itemsName = { ...analysis.itemsName } || {};
      const displayValueType =
        Filter.getInventorySummariesSettings("displayValue");

      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;

        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;
        return (content = (
          <Content
            title="INVENTORY SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            <table
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {this.setInOutItems(
                      summaries,
                      items,
                      "",
                      period.name,
                      displayValueType,
                      itemsName
                    )}
                  </Column>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr
                  style={{
                    borderTop: "2px solid black",
                  }}
                >
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </Content>
        ));
      });
    }

    return (
      <div className="ReceptBillSummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default InventoryImportSummary;
